import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "../../context/ThemeContext";
import defaultBot from "../../assets/common/resources/Sikibot.png";
import "./index.scss";

function Loader({ _class, wait, message }) {
  const themeContext = useTheme();
  const getLoadingConfig = themeContext?.getLoadingConfig;
  const loadingConfig =
    typeof getLoadingConfig === "function" ? getLoadingConfig() : {};

  const resolvedIcon = loadingConfig.icon || defaultBot;
  const resolvedAlt = loadingConfig.alt || "Loading";

  return (
    <Box className={_class ? _class : "__loader"}>
      {/* Ambient background orbs */}
      <div className="loader-bg-glow">
        <div className="loader-bg-orb loader-bg-orb-1" />
        <div className="loader-bg-orb loader-bg-orb-2" />
      </div>

      <div className="loader-container">
        {/* Logo block with rings and radial lines */}
        <div className="loader-logo-block">
          <div className="loader-glow" />

          {/* Radial tick marks */}
          <div className="loader-radial-lines">
            {Array.from({ length: 36 }).map((_, i) => (
              <div
                key={i}
                className="loader-radial-tick"
                style={{ transform: `rotate(${i * 10}deg)` }}
              />
            ))}
          </div>

          {/* Spinning rings */}
          <div className="loader-ring-outer" />
          <div className="loader-ring-mid" />
          <div className="loader-ring-inner" />

          {/* Center circle with bot */}
          <div className="loader-logo-center">
            <img
              src={resolvedIcon}
              alt={resolvedAlt}
              className="loader-bot-img"
            />
          </div>
        </div>

        {/* Progress bar */}
        <div className="loader-progress-wrap">
          <div className="loader-progress-track">
            <div className="loader-progress-fill" />
          </div>
        </div>

        {/* Text */}
        <Typography className="loader-title">
          {message || "Loading"}
        </Typography>
        <Typography className="loader-sub">
          We are preparing everything for you.
        </Typography>

        {/* Status dots */}
        <div className="loader-status-dots">
          <div className="loader-dot" />
          <div className="loader-dot" />
          <div className="loader-dot" />
        </div>
      </div>
    </Box>
  );
}

export default Loader;
